import { z } from "zod";

//
// Read
//

export const DTOAccessToken = z.object({
  id: z.string(),
  createdAt: z.coerce.date(),
  name: z.string(),
  scope: z.string().optional(),
});

export const DTOAccessTokenFull = DTOAccessToken.extend({
  token: z.string(),
});

export const DTOAccessTokenListResponse = z.object({
  tokens: DTOAccessToken.array(),
});

export const DTOAccessTokenResponse = z.object({
  token: DTOAccessToken,
});

export const DTOAccessTokenFullResponse = z.object({
  token: DTOAccessTokenFull,
});

export type DTOAccessToken = z.infer<typeof DTOAccessToken>;
export type DTOAccessTokenFull = z.infer<typeof DTOAccessTokenFull>;
export type DTOAccessTokenListResponse = z.infer<typeof DTOAccessTokenListResponse>;
export type DTOAccessTokenResponse = z.infer<typeof DTOAccessTokenResponse>;
export type DTOAccessTokenFullResponse = z.infer<typeof DTOAccessTokenFullResponse>;

//
// Write
//

export const DTOAccessTokenCreatePayload = z.object({
  name: z.string(),
  scope: z.string().optional(),
});

export type DTOAccessTokenCreatePayload = z.infer<typeof DTOAccessTokenCreatePayload>;
